import { InfoCard } from "../../shared/InfoCard";
import translationKeys from "../../../../contexts/I18nContext/translationKeys";
import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import { Translate, TranslateHtml } from "../../../Translation/Translate";
import {
  WhmButton,
  WhmDialog,
  WhmDialogActions,
  WhmDialogContent,
  WhmDialogTitle,
  WhmIconButton,
  WhmStack,
  WhmTypography,
} from "@securitize/reactjs-whm";
import { useRemoveAccessMutation } from "../../../../data/useProfile";
import { useContext, useState } from "react";
import { SnackbarContext } from "../../../shared/Snackbar";
import { ProfileContext } from "../../../../contexts/ProfileContext";
import closeIcon from "@securitize/assets-sec-ui/dist/icons/svg/exit.svg";
import ErrorSnackbar from "../../../shared/ErrorSnackbar";
import useUserInfo from "../../../../hooks/useUserInfo";
import { getIndividualInvestorId } from "../../../../helpers/userInfo";
import { CustomWhmLoadingButton } from "../../../shared/CustomWhmLoadingButton";

export default function SettingsRemoveAccessCard() {
  const { onSwitchToInvestor } = useContext(ProfileContext);
  const userInfo = useUserInfo();
  const individualInvestorId = getIndividualInvestorId(userInfo);
  const removeAccessMutation = useRemoveAccessMutation();
  const { showSnackbar } = useContext(SnackbarContext);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);

  const removeAccess = () =>
    removeAccessMutation.mutate(void 0, {
      onSuccess: () => {
        setIsConfirmDialogOpen(false);
        showSnackbar({
          severity: "info",
          message: (
            <Translate
              translationKey={
                translationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_SUCCESS
              }
            />
          ),
        });

        onSwitchToInvestor(individualInvestorId!);
      },
      onError: (error) => {
        showSnackbar({
          severity: "error",
          message: <ErrorSnackbar error={error} />,
        });
      },
    });

  return (
    <>
      <InfoCard
        title={
          <Translate
            translationKey={
              translationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_TITLE
            }
          />
        }
        subtitle={
          <Translate
            translationKey={
              translationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_SUBTITLE
            }
          />
        }
        action={
          <WhmButton
            variant="outlined"
            color="error"
            onClick={() => setIsConfirmDialogOpen(true)}
            sx={{
              minWidth: "fit-content !important",
              svg: {
                display: "block !important",
              },
              "&.MuiLoadingButton-root .MuiLoadingButton-loadingIndicator.MuiLoadingButton-loadingIndicatorCenter":
                {
                  position: "absolute !important",
                },
            }}
          >
            <Translate
              translationKey={
                translationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_CTA
              }
            />
          </WhmButton>
        }
        smallPadding
      />
      <WhmDialog open={isConfirmDialogOpen} maxWidth={"xs"}>
        <WhmDialogTitle variant="h4">
          <Translate
            translationKey={
              translationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_TITLE
            }
          />
        </WhmDialogTitle>
        <WhmIconButton
          aria-label="close"
          onClick={() => setIsConfirmDialogOpen(false)}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <img src={closeIcon} alt="close" />
        </WhmIconButton>

        <WhmDialogContent>
          <WhmTypography variant="body1">
            <TranslateHtml
              translationKey={
                TranslationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_SUBTITLE
              }
            />
          </WhmTypography>
        </WhmDialogContent>
        <WhmDialogActions>
          <WhmStack direction="row" justifyContent="flex-end" gap="8px">
            <WhmButton
              variant="outlined"
              color="secondary"
              disabled={removeAccessMutation.isPending}
              onClick={() => setIsConfirmDialogOpen(false)}
              sx={{
                minWidth: "fit-content !important",
              }}
            >
              <Translate
                translationKey={
                  translationKeys.DELETE_SECURITY_CARD_CONFIRM_CANCEL
                }
              />
            </WhmButton>
            <CustomWhmLoadingButton
              loading={removeAccessMutation.isPending}
              variant="contained"
              color="error"
              onClick={removeAccess}
            >
              <Translate
                translationKey={
                  removeAccessMutation.isPending
                    ? translationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_CTA_PENDING
                    : translationKeys.DELETE_SECURITY_CARD_REMOVE_ACCESS_CONFIRM_CTA
                }
              />
            </CustomWhmLoadingButton>
          </WhmStack>
        </WhmDialogActions>
      </WhmDialog>
    </>
  );
}
